import { Component, HostListener, OnInit } from '@angular/core';
import _ from 'lodash';
import { AnexoContratoResponse, FirmasFaltante } from 'src/app/global/interfaces/anexo-contrato-response';
import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { Nacionalidad } from 'src/app/global/interfaces/nacionalidad';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { ProductoDTO } from 'src/app/global/interfaces/productoDto';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { DatosSociosService } from 'src/app/global/services/datos-socios.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { PayProcessServiceVM } from 'src/app/view-model/services/pay-process.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SinActividadComponent } from 'src/app/main/dialogs/full-screem/sin-inicio/sin-actividad.component';
import { ValidacionCIPreFirmaVM } from 'src/app/view-model/providers/services/validacion-ci-prefirma/validacion-ci-prefirma.provider';


@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss']
})
export class TerminosCondicionesComponent implements OnInit {

  public productoDTO: ProductoDTO;
  public showTerminos: boolean;
  docURL: any;
  estadoFirma: boolean;
  isAceptaTerminos: boolean = false;
  isFirmado: boolean = false;
  debeAceptarTerminos: boolean = false;
  public anexosAceptar: AnexoContratoResponse;
  loading: boolean = false;
  loadingButton: boolean = false;
  runFirmante: number;
  dataPaso3: Paso3;
  screenSize: number;

  isPersonaNatural: boolean = this.localStorageService.getPaso1Login().currentIsPersonaNatural;
  listaRepresentantes: DatosPersonales[];
  public firmasFaltantes: Array<FirmasFaltante>;
  public firmarDoc: boolean = false;
  public runFirmador: number = null;
  public listSignersStore: Array<FirmasFaltante>;
  public listSignersView: Array<FirmasFaltante> = [];

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth
  }

  public loaginPDF: boolean = false;

  constructor(
    private cuentaAbonoSubject: CuentaAbonoSubject,
    private dialogService: DialogService,
    private anexoContratoService: AnexoContratoServiceVM,
    private localStorageService: LocalStorageService,
    private payProcessServiceVM: PayProcessServiceVM,
    private datosSociosService: DatosSociosService,
    private tagM:TagManagerService,
    private modalService: NgbModal,
    private validaCi:ValidacionCIPreFirmaVM
    
  ) {
    this.cuentaAbonoSubject.subTerminosyCondiciones$.subscribe((response) => {
      this.showTerminos = response;
    });
  }

  ngOnInit() {
    this.screenSize = window.innerWidth;
    this.dataPaso3 = this.localStorageService.getPaso3();

    // data = true, es editable
    if (!this.isPersonaNatural && this.dataPaso3.validaPaso3.data) {
      this.obtienesRepresentantes();
    }

    if (!this.dataPaso3.validaPaso3.data && this.isPersonaNatural) {
      this.getObtieneAnexos();
    } else if (!this.dataPaso3.validaPaso3.data && !this.isPersonaNatural) {
      this.getObtieneAnexosRRLL();
    }
  }

  init() {
    this.getPreviewDocumento();
  }

  async obtienesRepresentantes() {
    const fnSuccess = async (resp) => {
      if (resp != null) {
        this.listaRepresentantes = resp as DatosPersonales[];
        if (((this.listSignersStore == undefined || this.listSignersStore == null) && (this.firmasFaltantes == undefined || this.firmasFaltantes == null))
        || (this.listSignersStore.length === 0 && this.firmasFaltantes.length === 0)) {
          this.listaRepresentantes.forEach(representante => {
            let data: FirmasFaltante = {
              nombre: representante.nombre.nombres + ' ' + representante.nombre.apellidoPaterno + ' ' + representante.nombre.apellidoMaterno,
              nacionalidad: this.getNombrePais(representante.idNacionalidad),
              rut: Number(representante.run),
              estado: 'SIN_APROBAR', // default
              status: false // default
            }
            this.listSignersView.push(data);
          });
          this.firmarDoc = false;
        }
      }
    };
    const fnFailure = (error) => {
      console.error(error);
    };

    this.datosSociosService.getSociosRegistrados().subscribe(fnSuccess, fnFailure);
  }

  private getNombrePais(idNacionalidad: number): string {
    const pais: Nacionalidad = _.find(this.dataPaso3.nacionalidades, { id: idNacionalidad });
    return pais.nombre;
  }

  async continuarPaso3() {
    this.loadingButton = true;

    let gevent = GoogleTagManager.eventInteracciones().categoriaDetalleContratacion().accionClick();
    this.tagM.logEvent(gevent.setEtiqueta("continuar").setIsPersonaNatural(this.localStorageService.getPaso1().currentIsPersonaNatural));

    let response = await this.payProcessServiceVM.payProcess(false).catch(e => { 
      console.error(`e`, e) });
    if (response === 'AGENDAR_FECHA') {
      this.loadingButton = false;
      console.error('Error en la fecha seleccionada');
      this.dialogService.openFechaVencida();
    } else {
      this.loadingButton = false;
    }
  };

  previsualizarDocumento() {
    if (this.screenSize >= 960) {
      let dialogRef = this.dialogService.openPdfViewer(this.docURL);
      dialogRef.afterClosed().subscribe(resp => {
        if (resp.action === 'OK') {
          this.loaginPDF = false;
        }
      });
    } else {
      this.pdfMobile();
    }
  }

  private pdfMobile() {
    let byteCharacters = atob(this.docURL);
    let byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    let byteArray = new Uint8Array(byteNumbers);
    let file = new Blob([byteArray], { type: 'application/pdf;base64' });

    const pdfURL = (window.URL || window['webkitURL']).createObjectURL(file);
    const a = document.createElement('a');
    a.href = pdfURL;
    a.download = 'Preview_Contrato.pdf';
    a.target = '_blank';
    document.body.appendChild(a);
    //Se simula click sobre el link recientemente creado.
    a.click();
    document.body.removeChild(a);

    this.loaginPDF = false;
  }

  private getObtieneAnexos() {
    this.loading = true;
    const cbOK = response => {
      this.loading = false;
      this.anexosAceptar = response;
      if (!response.data.firmado) {
        this.debeAceptarTerminos = true;
        this.isFirmado = false;
        this.isAceptaTerminos = false;
      } else {
        this.debeAceptarTerminos = false;
        this.isFirmado = true;
        this.isAceptaTerminos = true;
      }
    };
    const cbError = error => {
      this.loading = false;
      console.error(error);
    }
    return this.anexoContratoService.getAnexoContrato().subscribe(cbOK, cbError);
  }

  private getObtieneAnexosRRLL() {
    this.loading = true;

    const cbOK = response => {
      this.loading = false;
      this.anexosAceptar = response;
      let store = this.localStorageService.getPaso3();
      this.listSignersStore = (store.lstFirmadores) ? store.lstFirmadores : [];
      this.firmasFaltantes = response.data.firmasFaltantes;
      if (this.listSignersStore.length !== 0 && this.firmasFaltantes.length !== 0) {
        let listFirma = [];
        this.firmasFaltantes.forEach(firmanteService => {
          let firmante = this.listSignersStore.filter(firmanteStore => firmanteStore.rut != firmanteService.rut);
          listFirma.push(firmante)
        });
        //let oneLevel: Array<FirmasFaltante> = listFirma[0];
        //this.listSignersView = [...this.firmasFaltantes, ...oneLevel];
        this.listSignersView = this.firmasFaltantes;
      } else if (this.listSignersStore.length !== 0 && this.firmasFaltantes.length === 0) {
        this.listSignersView = [...this.listSignersStore];
      } else {
        this.listSignersView = [...response.data.firmasFaltantes, ...this.listSignersStore];
      }

      this.isAceptaTerminos = response.data.firmado;
      this.firmarDoc = false;
    };

    const cbError = error => {
      this.loading = false;
      console.error(error);
    }
    return this.anexoContratoService.getAnexoContrato().subscribe(cbOK, cbError);
  }

  public async aceptarDocumentoRRLL(run: number) {
    try {
      this.firmarDoc = true;
      this.anexosAceptar = await this.anexoContratoService.getAnexoContrato().toPromise();
      this.firmasFaltantes = this.anexosAceptar.data.firmasFaltantes;
      this.runFirmador = run;
      const bodyApruebaDoc = {
        runRepresentante: this.runFirmador,
        tipoDocumento: this.anexosAceptar.data.tipoDocumento,
        tipoAprobacion: 'ACEPTA_TERMINOS_Y_CONDICIONES'
      };
  
      let responseFirma = await this.anexoContratoService.postApruebaDocumento(bodyApruebaDoc).toPromise();
      let firmante = this.firmasFaltantes.find(fF => fF.rut === this.runFirmador);
      let sThree = this.localStorageService.getPaso3();
      sThree.firmador = firmante;
      sThree.lstFirmadores = [...this.firmasFaltantes];
      this.localStorageService.setPaso3(sThree);
      if (responseFirma.data !== null && responseFirma.data !== undefined && responseFirma.data !== "") {
        this.listSignersView = [];
        this.listSignersStore = [];
        this.getObtieneAnexosRRLL();
      }
    } catch (error) {
      console.error('Error en aceptarDocumentoRRLL', error);
      if (
        error.error &&
        error.error.mensaje &&
        error.error.mensaje.contenido &&
        error.error.mensaje.contenido.includes('no tiene actividades economicas')
      ) {
        this.abrirModalSinActividad();
      }
        const contenido = _.get(error,'error.mensaje.contenido','');
        const estadoValidacionCI = await this.validaCi.assertCedulaIdentidadVigente(contenido,run);                 
        if(estadoValidacionCI ==='VALIDADO'){
            await this.aceptarDocumentoRRLL(run);//.catch(ee=>{throw ee});
            return;
        }
      this.firmarDoc = false;
    }
  }
  

  private abrirModalSinActividad() {
          this.modalService.open(SinActividadComponent, { centered: true, backdrop: 'static', keyboard: false });
        }

  public preview() {
    this.loaginPDF = true;
    this.getPreviewDocumento();
  }

  private getPreviewDocumento() {
    const cbOK = response => {
      this.docURL = response;
      this.previsualizarDocumento();
    };
    const cbError = error => {
      console.error(error);
    };
    return this.anexoContratoService.getPreviewDocumento().subscribe(cbOK, cbError);
  }

}
